module.exports = __webpack_public_path__ + "static/media/escudo-uabc.97847add.png";